import { useStyles } from '@archipro-design/aria';

import { useIsSafari } from '@modules/root/hook/use-is-safari';

import * as S from './CompanyProfile.style';
import { EnquiryInline } from '~/modules/enquiry/component/enquiry-inline/EnquiryInline';
import type { FavouriteItem } from '~/modules/design-board/type';
import { LoginEnquiryInline } from '~/modules/enquiry/component/login-enquiry-inline/LoginEnquiryInline';
import type { EnquiryProfessional } from '~/modules/enquiry/component/enquiry-form/EnquiryForm';
import { useABTestValue } from '~/modules/root/hook/use-growthbook';
import type { EnquiryItemType } from '../tracking/util/trackEnquireReveal';

import { useAppDisplayModeContext } from '@archipro-design/aria';

interface CompanyEnquiryFormData {
    Professional: EnquiryProfessional;
    showAddToDeisgnBoardInEnquiryForm?: boolean;
    messageBodyPlaceholder?: string;
    siteTreeID: number;
    favouriteItem?: FavouriteItem;
    showCustomEnquiryText: boolean;
    itemType: EnquiryItemType;
}

interface CompanyEnquiryFormProps {
    data: CompanyEnquiryFormData;
}

const CompanyEnquiryForm = ({ data }: CompanyEnquiryFormProps) => {
    const { Professional, favouriteItem, showCustomEnquiryText = false } = data;
    const isSafari = useIsSafari();
    const { css } = useStyles({ isSafari });

    const enquiryVariantControl = useABTestValue('upgraded-enquiry-flow');
    const isControlVariant = enquiryVariantControl === 'control';

    const { mobile: isMobile } = useAppDisplayModeContext();

    return (
        <div
            style={{ scrollBehavior: 'smooth' }}
            className={css(S.AnchorContainer)}
        >
            {isControlVariant ? (
                <EnquiryInline
                    professional={Professional}
                    submitButtonText={
                        isMobile
                            ? 'SEND'
                            : Professional.primaryCTA?.primaryCTALabel
                    }
                    messageBodyPlaceholder={data.messageBodyPlaceholder}
                    siteTreeID={data.siteTreeID}
                    showCustomEnquiryText={showCustomEnquiryText}
                    favouriteItem={favouriteItem}
                    itemType={data.itemType}
                />
            ) : (
                <LoginEnquiryInline
                    professional={Professional}
                    enquiryVariantControl={enquiryVariantControl}
                    messageBodyPlaceholder={data.messageBodyPlaceholder}
                    siteTreeID={data.siteTreeID}
                    showCustomEnquiryText={showCustomEnquiryText}
                    itemType={data.itemType}
                />
            )}
        </div>
    );
};

export default CompanyEnquiryForm;
